module.exports = __webpack_public_path__ + "img/bg61@2x.bcb93cb4.png";